"use strict";

var React = require("react"),
    PropTypes = require("prop-types"),
    classnames = require("classnames"),
    BaseModal = require("./BaseModal.js"),
    ButtonPrimary = require("../buttons/ButtonPrimary.js"),
    ButtonSecondary = require("../buttons/ButtonSecondary.js"),
    ButtonDanger = require("../buttons/ButtonDanger.js"),
    SuccessIcon = require("../icons/SuccessIcon.js"),
    InformationIcon = require("../icons/InformationIcon.js"),
    WarningIcon = require("../icons/WarningIcon.js"),
    ErrorIcon = require("../icons/ErrorIcon.js"),
    TYPE_MAP = {
  success: {
    className: "blx-success-modal",
    icon: SuccessIcon
  },
  information: {
    className: "blx-information-modal",
    icon: InformationIcon
  },
  warning: {
    className: "blx-warning-modal",
    icon: WarningIcon
  },
  error: {
    className: "blx-error-modal",
    icon: ErrorIcon
  }
},
    ActionModal = function ActionModal(e) {
  if (e.isHidden) return null;
  var n = null;

  if (e.onConfirm && e.confirmText) {
    var o = "warning" === e.variant ? ButtonDanger : ButtonPrimary;
    n = React.createElement(o, {
      text: e.confirmText,
      onClick: e.onConfirm
    });
  }

  var r = null;
  e.onCancel && e.cancelText && (r = React.createElement(ButtonSecondary, {
    text: e.cancelText,
    onClick: e.onCancel
  }));
  var a = null;
  (n || r) && (a = React.createElement("div", {
    className: "blx-h-button-group blx-modal-buttons"
  }, r, n));
  e.actionInfo && React.createElement("p", null, e.actionInfo);
  var t = TYPE_MAP[e.variant].icon;
  return React.createElement(BaseModal, {
    style: e.style,
    className: classnames("blx-action-modal", e.className, TYPE_MAP[e.variant].className),
    isHidden: e.isHidden,
    onClose: e.onClose
  }, React.createElement("div", {
    className: "blx-modal-content"
  }, React.createElement("div", {
    className: "blx-modal-title"
  }, React.createElement(t, {
    className: "blx-modal-icon"
  }), React.createElement("h4", null, e.title)), e.children), a);
};

ActionModal.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  isHidden: PropTypes.bool,
  title: PropTypes.string,
  confirmText: PropTypes.string,
  onConfirm: PropTypes.func,
  cancelText: PropTypes.string,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["success", "information", "warning", "error"]),
  children: PropTypes.node
}, ActionModal.defaultProps = {
  className: "",
  style: null,
  isHidden: !0,
  title: "",
  confirmText: "",
  onConfirm: null,
  cancelText: "",
  onCancel: null,
  onClose: function onClose() {},
  variant: "success",
  children: null
}, module.exports = ActionModal;